export var SyncBlockError = /*#__PURE__*/function (SyncBlockError) {
  SyncBlockError["Errored"] = "errored";
  SyncBlockError["NotFound"] = "not_found";
  SyncBlockError["Forbidden"] = "forbidden";
  return SyncBlockError;
}({});